export default (value, type, len) => {
  if (type === 'required') {
    // 非空验证
    return !(value === null || (value.trim && value.trim() === ''))
  }
  // 验证是否为合法的手机号码
  if (type === 'phone') {
    return /^1\d{10}$/.test(value)
  }
  // 验证是否为合法邮箱
  if (type === 'email') {
    return /^\w+@\w+(\.\w+)+$/.test(value)
  }
  // 验证是否为数字
  if (type === 'number') {
    return !isNaN(value)
  }
  // 邮政编码验证
  if (type === 'zip') {
    return /^\d{6}$/.test(value)
  }
  // 数字或英文字符
  if (type === 'number/en') {
    return /^[A-Za-z0-9]+$/g.test(value)
  }
  // 数字校验
  if (type === 'number') {
    return /^[0-9]+$/g.test(value)
  }
  // 校验字节数
  if (type === 'strLen') {
    let strLen = 0
    for (let i = 0; i < value.length; i++) {
      if (/[^\x00-\xff]/.test(value[i])) {
        strLen += 2
      } else {
        strLen += 1
      }
    }
    return strLen <= len
  }
  return false
}



// WEBPACK FOOTER //
// ./src/utils/validate.js